<template>
  <div>
    <div class="flex flex-col">
      <div class="w-full">
        <div>
          <vue-good-table
            ref="acTunnelTable"
            styleClass="vgt-table"
            row-style-class="text-sm"
            :columns="columns"
            :rows="alarm_logs"
            :sort-options="{
              enabled: false,
              multipleColumns: true,
              initialSortBy: serverParams.sort,
            }"
            :pagination-options="{
              enabled: true,
              perPage: 50,
              perPageDropdown: [50, 100, 200, 500],
              dropdownAllowAll: false,
            }"
            :line-numbers="true"
            mode="remote"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
            :totalRows="totalRecords"
            :isLoading.sync="isLoading"
          >
            <template slot="loadingContent">
              <div class="text-center text-2xl text-primary-500"><BaseIcon icon="spinner" spin /></div>
            </template>
            <div slot="table-actions">
              <button class="btn-secondary-outline mx-1" @click="resetTable()">
                {{ $t('alarm_center_report_log.reset') }}
                <BaseIcon icon="redo" class="ml-1" />
              </button>
              <button class="btn-blue mx-1" @click="exportXLS()">
                {{ $t('alarm_center_report_log.export') }}
                <BaseIcon icon="file-excel" class="ml-1" />
              </button>
            </div>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'delivery_status'">
                <template v-for="(v, i) in props.row.delivery_status">
                  <div v-bind:key="i" v-if="v.status != 'queued'">
                    <span class="rounded-lg bg-gray-600 text-white text-xxs px-1 uppercase mr-2">{{ v.order }}</span>
                    <span>{{ v.id }}</span>
                    <!-- <span v-if="v.status == 'queued'" class="rounded-lg bg-secondary-500 text-white text-xs px-2 ml-2">Kö</span> -->
                    <span v-if="v.status == 'sent'" class="rounded-lg bg-yellow-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.delivery_status_sent') }}</span>
                    <span v-else-if="v.status == 'delivered'" class="rounded-lg bg-success-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.delivery_status_delivered') }}</span>
                    <span v-else-if="v.status == 'not_sent'" class="rounded-lg bg-red-600 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.delivery_status_not_sent') }}</span>
                    <span v-else-if="v.status == 'failed'" class="rounded-lg bg-red-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.delivery_status_failed') }}</span>
                  </div>
                </template>
              </span>
              <span v-else-if="props.column.field == 'status'">
                <span v-if="props.row.status == 'pending'" class="rounded-lg bg-yellow-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.status_pending') }}</span>
                <span v-if="props.row.status == 'complete'" class="rounded-lg bg-success-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.status_complete') }}</span>
                <span v-else-if="props.row.status == 'failed'" class="rounded-lg bg-red-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.status_failed') }}</span>
              </span>
              <span v-else-if="props.column.field == 'view' && (user.role == 'admin' || user.role == 'seller')">
                <button class="btn-blue-outline" @click.prevent="showAlarmCenterReportModal(props.row)">{{ $t('alarm_center_report_log.view') }}</button>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>

    <modal name="modal-alarm-center-report-detail" class="modal-inner modal-alarm-center-report-detail" transition="pop-out" :width="modalWidth" :focus-trap="true" :min-height="200" height="auto" :scrollable="true" :resizable="true" :adaptive="true" :reset="true">
      <div class="px-3 py-3" v-if="alarmReportDetail != null">
        <div class="flex-col px-2 pt-2 pb-6 border border-secondary-400 rounded-sm text-sm">
          <div class="clear-both py-2">
            <div class="float-left font-semibold">
              {{ $t('alarm_center_report_log.imei') }}:
            </div>
            <div class="float-right">
              {{ alarmReportDetail.imei_number }}
            </div>
          </div>
          <div class="clear-both py-2">
            <div class="float-left font-semibold">
              {{ $t('alarm_center_report_log.phone_number') }}:
            </div>
            <div class="float-right">
              {{ alarmReportDetail.phone }}
            </div>
          </div>
          <div class="clear-both py-2">
            <div class="float-left font-semibold">
              {{ $t('alarm_center_report_log.unit_name') }}:
            </div>
            <div class="float-right">
              {{ getUnitName(alarmReportDetail.unit_id) }}
            </div>
          </div>
          <div class="clear-both py-2">
            <div class="float-left font-semibold">
              {{ $t('alarm_center_report_log.alarm_center') }}:
            </div>
            <div class="float-right">
              {{ getAlarmCenterName(alarmReportDetail.alarm_center_id) }}
            </div>
          </div>
          <div class="clear-both py-2">
            <div class="float-left font-semibold">
              {{ $t('alarm_center_report_log.type') }}:
            </div>
            <div class="float-right">
              <span>{{ getReportTypeName(alarmReportDetail.log_type) }}</span>
            </div>
          </div>
          <div class="clear-both py-2">
            <div class="float-left font-semibold">
              {{ $t('alarm_center_report_log.status') }}:
            </div>
            <div class="float-right">
              <span v-if="alarmReportDetail.status == 'pending'" class="rounded-lg bg-yellow-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.status_pending') }}</span>
              <span v-if="alarmReportDetail.status == 'complete'" class="rounded-lg bg-success-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.status_complete') }}</span>
              <span v-else-if="alarmReportDetail.status == 'failed'" class="rounded-lg bg-red-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.status_failed') }}</span>
            </div>
          </div>
          <div class="clear-both py-2">
            <div class="float-left font-semibold">
              {{ $t('alarm_center_report_log.modal_receipts') }}:
            </div>
            <div class="float-right">
              <div v-for="(v, i) in alarmReportDetail.delivery_status" :key="i" class="mt-1">
                <span class="rounded-lg bg-gray-600 text-white text-xxs px-1 uppercase mr-2">{{ v.order }}</span>
                <span class="rounded-lg bg-primary-500 text-white text-xxs px-1 uppercase mr-2">{{ v.type }}</span>
                <span>{{ v.id }}</span>
                <span v-if="v.status == 'queued'" class="rounded-lg bg-secondary-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.delivery_status_queued') }}</span>
                <span v-if="v.status == 'sent'" class="rounded-lg bg-yellow-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.delivery_status_sent') }}</span>
                <span v-else-if="v.status == 'delivered'" class="rounded-lg bg-success-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.delivery_status_delivered') }}</span>
                <span v-else-if="v.status == 'not_sent'" class="rounded-lg bg-red-600 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.delivery_status_not_sent') }}</span>
                <span v-else-if="v.status == 'failed'" class="rounded-lg bg-red-500 text-white text-xs px-2 ml-2">{{ $t('alarm_center_report_log.delivery_status_failed') }}</span>
                <span v-if="v.timestamp" class="text-xxs text-secondary-500 ml-2">{{ formatDate(v.timestamp) }}</span>
                <span v-if="v.report" class="text-xxs text-secondary-500 ml-2">
                  <p class="text-xs font-sans whitespace-pre-wrap text-xxs text-secondary-500">{{ v.report }}</p>
                </span>
              </div>
            </div>
          </div>
          <div v-if="alarmReportDetail.report_string" class="clear-both py-2">
            <div class="float-left font-semibold">
              {{ $t('alarm_center_report_log.modal_ovls_string') }}:
            </div>
            <div class="float-right">
              <pre class="text-xs font-sans whitespace-pre-wrap text-xxs" v-html="alarmReportDetail.report_string"></pre>
            </div>
          </div>
          <div class="clear-both py-2">
            <div class="float-left font-semibold">
              {{ $t('alarm_center_report_log.modal_log') }}:
            </div>
            <div class="float-right">
              <div v-for="(l, i) in alarmReportDetail.log" :key="i" class="text-xs">
                <span class="text-xxs text-secondary-500 mr-2">{{ formatDate(l.timestamp) }}</span>
                {{ l.message }}
              </div>
            </div>
          </div>
          <div class="clear-both py-2">
            <div class="float-left font-semibold">
              {{ $t('alarm_center_report_log.date') }}:
            </div>
            <div class="float-right">
              {{ this.formatDate(alarmReportDetail.createdAt) }}
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
const MODAL_WIDTH = 1100;

export default {
  name: "AlarmCenterReportLog",
  title() {
    return this.$t('alarm_center_report_log.page_title');
  },
  data() {
    return {
      id: this.$route.params.id,
      isLoading: false,
      totalRecords: 0,
      alarm_logs: [],
      units: [],
      alarm_centers: [],
      alarmReportDetail: null,
      serverParams: {
        filters: {},
        sort: [{ field: "createdAt", type: "desc" }],
        page: 1,
        perPage: 50,
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    columns() {
      const baseColumns = [
        { label: this.$t('alarm_center_report_log.imei'), field: "imei_number" },
        { label: this.$t('alarm_center_report_log.phone_number'), field: "phone" },
        { label: this.$t('alarm_center_report_log.unit_name'), field: "unit_id", formatFn: this.getUnitName },
      ];

      if (this.user.role == "admin" || this.user.role == "seller") {
        baseColumns.push({
          label: this.$t('alarm_center_report_log.alarm_center'),
          field: "alarm_center_id",
          formatFn: this.getAlarmCenterName,
          filterOptions: { enabled: true, placeholder: this.$t('alarm_center_report_log.alarm_center'), filterDropdownItems: [] }
        });
      }

      baseColumns.push(
        { label: this.$t('alarm_center_report_log.type'), field: "log_type", formatFn: this.getReportTypeName, sortable: true },
        { label: this.$t('alarm_center_report_log.status'), field: "status", sortable: true },
        { label: this.$t('alarm_center_report_log.receipts'), field: "delivery_status" },
        { label: this.$t('alarm_center_report_log.date'), field: "createdAt", type: "date", formatFn: this.formatDate, sortable: true },
        { label: "", field: "view" }
      );

      return baseColumns;
    },
  },

  methods: {
    async getAlarmCenterReportLog() {
      try {
        let response = await this.axios.post(`${process.env.VUE_APP_SERVER_URL}/alarm-center/securcloud/report`, this.serverParams);
        this.alarm_logs = response.data.alarm_logs;
        this.totalRecords = response.data.totalRecords;
      } catch (error) {
        this.handleError(error);
      }
    },

    getListCustomer() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/list/customer`)
        .then((response) => {
          this.units = response.data.units;
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    getListAlarmCenter() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/list/alarm-center`)
        .then((response) => {
          this.alarm_centers = response.data.alarm_centers;
          let alarmcenter_names = _.map(this.alarm_centers, function(o) {
            return { value: o._id, text: o.name };
          });
          let alarmcenter_col = _.find(this.columns, { field: "alarm_center_id" });
          if (alarmcenter_col) {
            alarmcenter_col.filterOptions.filterDropdownItems = alarmcenter_names;
          }
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    exportXLS() {
      let export_columns = [];

      this.alarm_logs.forEach((log) => {
        export_columns.push({
          [this.$t('alarm_center_report_log.imei')]: log.imei_number,
          [this.$t('alarm_center_report_log.phone_number')]: log.phone,
          [this.$t('alarm_center_report_log.type')]: this.getReportTypeName(log.log_type),
          [this.$t('alarm_center_report_log.date')]: this.formatDate(log.createdAt),
        });
      });

      this.excelExport(export_columns, this.$t('alarm_center_report_log.page_title'), this.$t('alarm_center_report_log.export_filename'));
    },

    getReportTypeName(type) {
      if (type == "push_button") return this.$t('alarm_center_report_log.report_type_push_button');
      else if (type == "man_down") return this.$t('alarm_center_report_log.report_type_man_down');
      else if (type == "timer_alarm_stop") return this.$t('alarm_center_report_log.report_type_timer_alarm_stop');
      else if (type == "call_b") return this.$t('alarm_center_report_log.report_type_call_b');
      else return type;
    },

    getUnitName(unit_id) {
      let u = _.find(this.units, { unit_id: unit_id });
      if (u) return u.name;
      else return "";
    },

    getAlarmCenterName(_id) {
      let a = _.find(this.alarm_centers, { _id: _id });
      if (a) return a.name;
      else return "";
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getAlarmCenterReportLog();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getAlarmCenterReportLog();
    },

    onSortChange(params) {
      this.updateParams({ sort: params });
      this.getAlarmCenterReportLog();
    },

    onColumnFilter(params) {
      let filters = params.columnFilters;

      for (const key in filters) {
        if (Object.hasOwnProperty.call(filters, key)) {
          if (filters[key] == "") delete filters[key];
        }
      }

      this.updateParams({ filters, page: 1 });
      this.getAlarmCenterReportLog();
    },

    resetTable() {
      this.serverParams.filters = {};
      
      // Restore alarm_center_id filter if we're viewing a specific alarm center
      if (this.id && this.id !== '-') {
        this.serverParams.filters.alarm_center_id = this.id;
      }
      
      this.serverParams.sort = { field: "createdAt", type: "desc" };
      this.serverParams.page = 1;
      this.$refs["acTunnelTable"].globalSearchTerm = "";
      this.$refs["acTunnelTable"].reset();
    },

    showAlarmCenterReportModal(log) {
      this.alarmReportDetail = _.cloneDeep(log);
      this.$modal.show("modal-alarm-center-report-detail");
    },

    formatDate(date) {
      if (this.user.role == "admin") return this.moment(date).format("YYYY-MM-DD HH:mm:ss");
      else return this.moment(date).format("YYYY-MM-DD HH:mm");
    },
  },
  
  watch: {
    // Watch for route parameter changes
    '$route.params.id'(newId, oldId) {
      if (newId !== oldId) {
        this.id = newId;
        
        // Update filter based on new id
        if (newId && newId !== '-') {
          this.serverParams.filters.alarm_center_id = newId;
        } else {
          // If id is '-', remove the alarm_center_id filter to show all
          delete this.serverParams.filters.alarm_center_id;
        }
        
        // Reset to page 1 and fetch new data
        this.serverParams.page = 1;
        this.getAlarmCenterReportLog();
      }
    }
  },

  created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? window.innerWidth : MODAL_WIDTH;

    this.getListCustomer();

    if (this.user.role == "admin" || this.user.role == "seller") this.getListAlarmCenter();

    // If id is not '-' (meaning a specific alarm center), add it to filters
    if (this.id && this.id !== '-') {
      this.serverParams.filters.alarm_center_id = this.id;
    }

    this.setPageTitle(this.$t('alarm_center_report_log.page_title'), "alarm_center_email_log");
    
    // Fetch initial data
    this.getAlarmCenterReportLog();
  },
};
</script>

<style scoped>
.modal-alarm-center-report-detail :deep(.vm--modal) {
  max-width: 1200px;
  width: 95vw;
}

.modal-alarm-center-report-detail :deep(.vm--modal-body) {
  max-height: 85vh;
  overflow: auto;
}

.modal-alarm-center-report-detail .float-left {
  max-width: 30%;
}

.modal-alarm-center-report-detail .float-right {
  max-width: 70%;
  word-break: break-word;
}
</style>
